export const SET_ANALYZE = "MONITORING/SET_ANALYZE";
export const SET_POSITIVE = "MONITORING/SET_POSITIVE";
export const SET_NEGATIVE = "MONITORING/SET_NEGATIVE";
export const SET_ANALYZE_PRESENTIAL = "MONITORING/SET_ANALYZE_PRESENTIA";
